import ApiCall from "../constants/Api";
import SiteConfig from "../constants/SiteConfig";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useDeleteFunctions = () => {
  const voidWagerList = async (request, session) => {
    //Call method voidwagerlist

    let response;
    try {
      response = await helpAxios(
        SiteConfig.WAGER_POST_SVC,
        ApiCall.VOID_WAGER_LIST,
        request,
        session
      );
      if (response.error) {
        // Show error message
        errorHandler(response.error, response.errorDetails);
      }
    } catch {
      errorHandler(response.error.toString());
    }

    return response;
  };

  return {
    voidWagerList,
  };
};
